import { render, staticRenderFns } from "./ReporteSaldosPartidas.vue?vue&type=template&id=64f29c29&"
import script from "./ReporteSaldosPartidas.vue?vue&type=script&lang=js&"
export * from "./ReporteSaldosPartidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports